/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { BackendMlProjectDto } from '../models/backend-ml-project-dto';
import { BackendMlScenarioDto } from '../models/backend-ml-scenario-dto';
import { monitoringCheckAuthorRetrieve } from '../fn/monitoring-helpers/monitoring-check-author-retrieve';
import { MonitoringCheckAuthorRetrieve$Params } from '../fn/monitoring-helpers/monitoring-check-author-retrieve';
import { monitoringDaterangesRetrieve } from '../fn/monitoring-helpers/monitoring-dateranges-retrieve';
import { MonitoringDaterangesRetrieve$Params } from '../fn/monitoring-helpers/monitoring-dateranges-retrieve';
import { monitoringProjectsList } from '../fn/monitoring-helpers/monitoring-projects-list';
import { MonitoringProjectsList$Params } from '../fn/monitoring-helpers/monitoring-projects-list';
import { monitoringScenariosList } from '../fn/monitoring-helpers/monitoring-scenarios-list';
import { MonitoringScenariosList$Params } from '../fn/monitoring-helpers/monitoring-scenarios-list';
import { monitoringUserIdRetrieve } from '../fn/monitoring-helpers/monitoring-user-id-retrieve';
import { MonitoringUserIdRetrieve$Params } from '../fn/monitoring-helpers/monitoring-user-id-retrieve';

@Injectable({ providedIn: 'root' })
export class BackendApiMonitoringHelpersService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `monitoringCheckAuthorRetrieve()` */
  static readonly MonitoringCheckAuthorRetrievePath = '/api/monitoring/check_author/{scenario_id}/';

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringCheckAuthorRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringCheckAuthorRetrieve$Response(
    params: MonitoringCheckAuthorRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return monitoringCheckAuthorRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringCheckAuthorRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringCheckAuthorRetrieve(params: MonitoringCheckAuthorRetrieve$Params, context?: HttpContext): Observable<void> {
    return this.monitoringCheckAuthorRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `monitoringDaterangesRetrieve()` */
  static readonly MonitoringDaterangesRetrievePath = '/api/monitoring/dateranges/{scenario_id}/';

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringDaterangesRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringDaterangesRetrieve$Response(
    params: MonitoringDaterangesRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return monitoringDaterangesRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringDaterangesRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringDaterangesRetrieve(params: MonitoringDaterangesRetrieve$Params, context?: HttpContext): Observable<void> {
    return this.monitoringDaterangesRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `monitoringProjectsList()` */
  static readonly MonitoringProjectsListPath = '/api/monitoring/projects/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringProjectsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringProjectsList$Response(
    params?: MonitoringProjectsList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendMlProjectDto>>> {
    return monitoringProjectsList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringProjectsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringProjectsList(
    params?: MonitoringProjectsList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendMlProjectDto>> {
    return this.monitoringProjectsList$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendMlProjectDto>>): Array<BackendMlProjectDto> => r.body),
    );
  }

  /** Path part for operation `monitoringScenariosList()` */
  static readonly MonitoringScenariosListPath = '/api/monitoring/scenarios/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringScenariosList()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringScenariosList$Response(
    params?: MonitoringScenariosList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendMlScenarioDto>>> {
    return monitoringScenariosList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringScenariosList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringScenariosList(
    params?: MonitoringScenariosList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendMlScenarioDto>> {
    return this.monitoringScenariosList$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendMlScenarioDto>>): Array<BackendMlScenarioDto> => r.body),
    );
  }

  /** Path part for operation `monitoringUserIdRetrieve()` */
  static readonly MonitoringUserIdRetrievePath = '/api/monitoring/user_id/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringUserIdRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringUserIdRetrieve$Response(
    params?: MonitoringUserIdRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return monitoringUserIdRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringUserIdRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringUserIdRetrieve(params?: MonitoringUserIdRetrieve$Params, context?: HttpContext): Observable<void> {
    return this.monitoringUserIdRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }
}
